import {ViewerParameters} from "../bean/ViewerParameters";
import {DataRow} from "../bean/DataRow";
import {EnrichedDataRow} from "../bean/EnrichedDataRow";

export class AdditionalDataComputer {

  public compute(parameters: ViewerParameters, row: DataRow) : EnrichedDataRow {

    const o = new EnrichedDataRow();
    const UA = 149597870700;

    o.timeJulian = row.timeJulian;
    o.timeJ2000 = row.timeJ2000;
    o.frequency = row.frequency;
    o.dsn = row.dsn;

    /*
    C9 = parameters.earth.initialAnomaly
    C8 = parameters.earth.averageMovement


    D9 = parameters.mars.initialAnomaly
    D8 = parameters.mars.averageMovement

    J7 = parameters.initialMissionTime
    M4 = parameters.observationDay

     */


    // A49 = =J7+M4
    let timeSinceJ2000 = parameters.initialMissionTime + (row.rowNumber - 1) * parameters.graphTimeframe;

    // B49 = =A49-$J$7
    let timeSinceMissionStart = 1.0*(timeSinceJ2000 - parameters.initialMissionTime);

    // C49 = =A49/365.25
    let timeInYears = timeSinceJ2000 / 365.25;

    // D49 = =$C$9+A49*$C$8
    let earthAverageAnomaly = parameters.earth.initialAnomaly + timeSinceJ2000 * parameters.earth.averageMovement;

    // E49 = =$D$9+A49*$D$8
    let marsAverageAnomaly = parameters.mars.initialAnomaly + timeSinceJ2000 * parameters.mars.averageMovement;

    // F49 =$C$5*(COS($C$10+D49)+$C$6/2*(-3*COS($C$10)+COS(2*D49+$C$10)))

    let earthMajorSemiAxisInMeters = parameters.earth.majorSemiAxis * UA;
    let earthPositionX = earthMajorSemiAxisInMeters * (
        Math.cos(parameters.earth.initialPhase + earthAverageAnomaly)
      + (parameters.earth.excentricity/2.0) * (-3 * Math.cos(parameters.earth.initialPhase) + Math.cos(2 * earthAverageAnomaly + parameters.earth.initialPhase))
    );

    // G49 =$C$5*(SIN($C$10+D49)+$C$6/2*(-3*SIN($C$10)+SIN(2*D49+$C$10)))
    let earthPositionY = earthMajorSemiAxisInMeters * (
      Math.sin(parameters.earth.initialPhase + earthAverageAnomaly)
      + (parameters.earth.excentricity/2.0) * (-3 * Math.sin(parameters.earth.initialPhase) + Math.sin(2 * earthAverageAnomaly + parameters.earth.initialPhase))
    );

    // H49 = =$D$5*(COS($D$10+E49)+$D$6/2*(-3*COS($D$10)+COS(2*E49+$D$10)))
    let marsMajorSemiAxisInMeters = parameters.mars.majorSemiAxis * UA;
    let marsPositionX = marsMajorSemiAxisInMeters * (
      Math.cos(parameters.mars.initialPhase + marsAverageAnomaly)
      + (parameters.mars.excentricity/2.0) * (-3 * Math.cos(parameters.mars.initialPhase) + Math.cos(2 * marsAverageAnomaly + parameters.mars.initialPhase))
    );

    // I49 =$D$5*(SIN($D$10+E49)+$D$6/2*(-3*SIN($D$10)+SIN(2*E49+$D$10)))
    let marsPositionY = marsMajorSemiAxisInMeters * (
      Math.sin(parameters.mars.initialPhase + marsAverageAnomaly)
      + (parameters.mars.excentricity/2.0) * (-3 * Math.sin(parameters.mars.initialPhase) + Math.sin(2 * marsAverageAnomaly + parameters.mars.initialPhase))
    );

    // =SQRT((F49-H49)^2+(G49-I49)^2)
    o.earthMarsDistance = Math.sqrt((marsPositionX - earthPositionX)**2 + (marsPositionY - earthPositionY) **2);

    // Write intermediate values
    o.timeSinceJ2000 = timeSinceJ2000;
    o.timeSinceMissionStart = timeSinceMissionStart;
    o.timeInYears = timeInYears;
    o.earthAverageAnomaly = earthAverageAnomaly;
    o.marsAverageAnomaly = marsAverageAnomaly;
    o.earthPositionX = earthPositionX;
    o.earthPositionY = earthPositionY;
    o.marsPositionX = marsPositionX;
    o.marsPositionY = marsPositionY;

    return o;
  }
}
